// src/json/servicesOverview.json
export const servicesOverview = {
    eyebrow: "OUR CAULKING & SEALANT",
    titleHighlight: "SERVICES INCLUDE:",
    items: [
        {
            title: "Joint & Expansion Sealant Replacement",
            description: "Removing and replacing deteriorated sealants in expansion joints, control joints, and façade connections."
        },
        {
            title: "Window & Door Perimeter Sealing",
            description: "Ensuring a tight seal around windows and doors to prevent drafts, leaks, and energy loss."
        },
        {
            title: "Curtain Wall & Glazing Sealant Renewal",
            description: "Protecting glass curtain walls and window systems from water penetration and air infiltration."
        },
        {
            title: "Concrete, Masonry & Cladding Sealing",
            description: "Reinforcing connections between building materials to maintain structural integrity and prevent deterioration."
        },
        {
            title: "Elastomeric & Silicone Sealant Application",
            description: "Using high-performance, weather-resistant sealants for maximum durability and flexibility."
        }
    ],
    imageUrl: "/assets/imgs/services/2Caulking&SealantRenewal/servicesOverview/fondo.jpg",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  